import { render, staticRenderFns } from "./ServidorPublicoExercito.vue?vue&type=template&id=256b1fe8"
import script from "./ServidorPublicoExercito.vue?vue&type=script&lang=js"
export * from "./ServidorPublicoExercito.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublicoExercito.vue?vue&type=style&index=0&id=256b1fe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports